import { EstablishmentHeaderPropType } from "../types";

const EstablishmentHeader = ({
  color,
  image,
  name,
  onClick,
}: EstablishmentHeaderPropType) => {
  return (
    <div
      className="flex flex-col justify-center items-center gap-3 hover:scale-105 font-bold hover:font-extrabold delay-75 transition cursor-pointer"
      onClick={onClick}
    >
      <div
        className="w-full h-full rounded-md md:rounded-3xl flex flex-col justify-between items-center gap-4 p-2"
        style={{ backgroundColor: color }}
      >
        <img src={image} alt="" className="w-8 h-8" />
        <div className=" text-[#000000] text-xs md:text-base">{name}</div>
      </div>
    </div>
  );
};

export default EstablishmentHeader;
